/* Purevia: enriched Klaviyo "Added to Cart" event.
 *
 * Why this exists (2026-08-15):
 * The existing "Added to Cart" metric in Klaviyo (UTEpuE) is fired server side by
 * a third party and carries only VariantID, ProductID, Price, Quantity and page.
 * No product name, no image, no URL, so item.product.* renders empty and the
 * abandoned cart emails cannot show what she was buying. The Klaviyo product
 * catalog is also empty, so a catalog lookup is not available as a fallback.
 *
 * This fires a SEPARATE metric, "Added to Cart Enriched", carrying the full
 * product data plus the whole cart. It is deliberately a new metric rather than
 * the same name: the existing emitter cannot be switched off from here, and
 * firing a second event onto the live metric would enter profiles into the live
 * abandoned cart flow twice.
 *
 * Everything is wrapped so that a failure here can never block an add to cart.
 */
(function () {
  'use strict';

  var METRIC = 'Added to Cart Enriched';
  var DEBOUNCE_MS = 1500;
  var lastKey = '';
  var lastAt = 0;

  function learnq() {
    window._learnq = window._learnq || [];
    return window._learnq;
  }

  function abs(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.indexOf('http') === 0) return url;
    return window.location.origin + url;
  }

  function money(cents) {
    return typeof cents === 'number' ? Math.round(cents) / 100 : null;
  }

  function currency() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return 'USD';
  }

  function sellingPlan(item) {
    try {
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        return item.selling_plan_allocation.selling_plan.name || '';
      }
    } catch (e) {}
    return '';
  }

  function shape(item) {
    return {
      ProductName: item.product_title || item.title || '',
      ProductID: item.product_id || null,
      VariantID: item.variant_id || item.id || null,
      VariantName: item.variant_title || '',
      SKU: item.sku || '',
      ImageURL: abs(item.image || (item.featured_image && item.featured_image.url) || ''),
      URL: abs(item.url || (item.handle ? '/products/' + item.handle : '')),
      Price: money(item.price),
      Quantity: item.quantity || 1,
      LineTotal: money(item.line_price != null ? item.line_price : item.price * (item.quantity || 1)),
      SellingPlan: sellingPlan(item)
    };
  }

  function restoreUrl(items) {
    try {
      var parts = items
        .filter(function (i) { return i.id && i.quantity; })
        .map(function (i) { return i.id + ':' + i.quantity; });
      if (!parts.length) return '';
      return window.location.origin + '/cart/' + parts.join(',') + '?storefront=true';
    } catch (e) {
      return '';
    }
  }

  function send(added) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var shaped = items.map(shape);
        var first = added || items[items.length - 1] || {};
        var a = shape(first);

        var key = String(a.VariantID) + ':' + String(a.Quantity) + ':' + items.length;
        var now = Date.now();
        if (key === lastKey && now - lastAt < DEBOUNCE_MS) return;
        lastKey = key;
        lastAt = now;

        var props = {
          $event_id: 'pv-atc-' + now + '-' + (a.VariantID || '0'),
          $value: money(cart.total_price),
          $value_currency: currency(),

          AddedItemProductName: a.ProductName,
          AddedItemProductID: a.ProductID,
          AddedItemVariantID: a.VariantID,
          AddedItemVariantName: a.VariantName,
          AddedItemSKU: a.SKU,
          AddedItemImageURL: a.ImageURL,
          AddedItemURL: a.URL,
          AddedItemPrice: a.Price,
          AddedItemQuantity: a.Quantity,
          AddedItemSellingPlan: a.SellingPlan,

          ItemNames: shaped.map(function (i) { return i.ProductName; }),
          Items: shaped,

          CartTotal: money(cart.total_price),
          CartItemCount: cart.item_count || 0,
          CartURL: window.location.origin + '/cart',
          CartRestoreURL: restoreUrl(items),
          PageURL: window.location.href
        };

        learnq().push(['track', METRIC, props]);
      })
      .catch(function () { /* never surface to the shopper */ });
  }

  function isAdd(url) {
    try {
      return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    } catch (e) {
      return false;
    }
  }

  function parseAdded(text) {
    try {
      var d = JSON.parse(text);
      if (d && d.items && d.items.length) return d.items[d.items.length - 1];
      if (d && (d.product_id || d.variant_id || d.id)) return d;
    } catch (e) {}
    return null;
  }

  /* fetch */
  try {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function () {
        var args = arguments;
        var target = args[0];
        var url = typeof target === 'string' ? target : (target && target.url) || '';
        var p = nativeFetch.apply(this, args);
        if (isAdd(url)) {
          p.then(function (res) {
            try {
              if (!res || !res.ok) return;
              res.clone().text().then(function (t) { send(parseAdded(t)); });
            } catch (e) {}
          }).catch(function () {});
        }
        return p;
      };
    }
  } catch (e) {}

  /* XMLHttpRequest */
  try {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (isAdd(url)) {
          this.addEventListener('load', function () {
            try {
              if (this.status >= 200 && this.status < 300) {
                send(parseAdded(this.responseText));
              }
            } catch (e) {}
          });
        }
      } catch (e) {}
      return open.apply(this, arguments);
    };
  } catch (e) {}
})();
